import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import languageDetector from './utils/languageDetector';

i18n
  .use(Backend)
  // detect user language
  .use(languageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ['account'],
    defaultNS: 'account',
    whitelist: ['en', 'it', 'it-CH', 'fr', 'fr-CH', 'de', 'de-CH'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// set the language to contry-code free variant
i18n.on('languageChanged', lng => {
  if (lng.indexOf('-') > -1) {
    i18n.changeLanguage(lng.split('-')[0]);
  }
});

export default i18n;
